import useSWRMutation from 'swr/mutation';
import NudosTextInput from '../../../../../../../components/NudosComponents/NudosTextInput/NudosTextInput';
import NudosFileInput from '../../../../../../../components/NudosComponents/NudosFileInput/NudosFileInput';
import NudosButton from '../../../../../../../components/NudosComponents/NudosButton/NudosButton';
import { bordColorTheme } from '../../../../../../../styles/styles.constants';
import { IStockOrderBillingData, IStockOrderDetail } from '../../../../../../../types/stockOrders';
import { SWR_KEYS } from '../../../../../../../constants/constants';
import { createStockOrderInvoice, updateStockOrderBillingData } from '../../../../../../../services/stockOrders';
import { useParams } from 'react-router-dom';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../../utils/displayNudosStandardNotifications';
import { useState } from 'react';
import './BillingProviderInfo.scss';

const BillingProviderInfo = ({
  providerOrderNumber,
  setProviderOrderNumber,
  providerInvoiceNumber,
  setProviderInvoiceNumber,
  billingData,
  updateWithoutLoaders
}: {
  providerOrderNumber: string;
  setProviderOrderNumber: (value: string) => void;
  providerInvoiceNumber: string;
  setProviderInvoiceNumber: (value: string) => void;
  billingData: IStockOrderDetail['billingData'];
  updateWithoutLoaders: () => Promise<void>;
}) => {
  const { uuid } = useParams<{ uuid: string }>();
  const isButtonInvoiceNumberDisabled = !providerOrderNumber || !providerInvoiceNumber;
  const [loading, setLoading] = useState(false);

  const { trigger: updateStockOrderBillingDataTrigger, isMutating: isLoadingUpdateStockOrderBillingData } =
    useSWRMutation(
      SWR_KEYS.updateStockOrderBillingData,
      async (
        __,
        {
          arg
        }: {
          arg: Pick<IStockOrderBillingData, 'providerOrderNumber' | 'providerInvoiceNumber'>;
        }
      ) => updateStockOrderBillingData(uuid, arg),
      {
        onSuccess: () => {
          updateWithoutLoaders();
          displaySuccessNotification({
            customJSXMessage: <>Informacion actualizada correctamente</>
          });
        }
      }
    );

  const verifyFileDocument = (file: File) => {
    const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    const isDocument = extension === '.docx' || extension === '.pdf';
    const size = file.size / 1024 / 1024 < 3;
    if (!isDocument) {
      displayErrorNotification({ customJSXMessage: <>solo puedes subir archivos .docx/.pdf</> });
      return true;
    } else if (!size) {
      displayErrorNotification({ customJSXMessage: <>el archivo debe pesar menos de 3MB</> });
    }
    return false;
  };

  const uploadOrderInvoice = async (file: string | Blob | File | any) => {
    const incorrectFile = verifyFileDocument(file);
    if (file && !incorrectFile) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append('file', file);
        await createStockOrderInvoice(formData, uuid);
        displaySuccessNotification({
          customJSXMessage: <>Factura actualizada correctamente</>
        });
        updateWithoutLoaders();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        displayErrorNotification({ customJSXMessage: <>Ha ocurrido un error</> });
      }
    }
  };

  const openInvoice = (url: string) => {
    if (url) window.open(url, '_blank');
  };

  return (
    <section className="billingProviderInfo">
      <h2 className="sectionTitle">Facturación del proveedor</h2>
      <div className="billingProviderInfoFields">
        <NudosTextInput
          label="N° de orden de proveedor*"
          defaultValue={providerOrderNumber}
          handleChange={setProviderOrderNumber}
          isFilled
          placeholder="N° de orden de proveedor"
          componentSize="medium"
        />
        <NudosTextInput
          label="N° de factura"
          defaultValue={providerInvoiceNumber}
          handleChange={setProviderInvoiceNumber}
          isFilled
          placeholder=""
          componentSize="medium"
        />
        <div className="invoiceUploadAndDownload">
          <NudosFileInput
            uploadedFileHandler={uploadOrderInvoice}
            buttonText={billingData?.providerInvoiceUrl ? 'Actualizar factura' : 'Subir factura'}
            isFilled={!!billingData?.providerInvoiceUrl}
            color="orange"
            isLoading={loading}
            isDisabled={loading}
            customBg={bordColorTheme.white[50]}
          />
          <div
            onClick={() => openInvoice(billingData?.providerInvoiceUrl || '')}
            className={`downloadInvoice ${billingData?.providerInvoiceUrl ? 'existUrl' : 'noUrl'}`}
          >
            Ver factura de la orden
          </div>
        </div>
        <div className="containerButtonInvoiceNumber">
          <NudosButton
            customClassName="mySizeButton"
            customWidth="80px"
            customHeight="18px"
            buttonText="Guardar"
            isButtonLoading={isLoadingUpdateStockOrderBillingData}
            handleClick={() => {
              updateStockOrderBillingDataTrigger({
                providerOrderNumber,
                providerInvoiceNumber
              });
            }}
            isButtonDisabled={isButtonInvoiceNumberDisabled}
          />
        </div>
      </div>
    </section>
  );
};

export default BillingProviderInfo;
